export const serviceGroups = [
  {
    name: 'Brand IDs',
    description:
      'Positioning, naming and complete identity systems for brands that seek substance — crafted by hand and accelerated by algorithmic precision.',
  },
  {
    name: 'Terminals',
    description:
      'High-speed Webflow and Vercel terminals: editorial, quietly confident digital presences, designed and live in days rather than months.',
  },
  {
    name: 'Cinematic Media',
    description:
      'Cinematic films, campaigns and media assets for luxury hotels, watch manufactures and haute parfumerie, produced in-house as one system.',
  },
  {
    name: 'Visual Intelligence',
    description:
      'Construction-phase tracking, renderings and off-market asset visuals for prime real estate in Dubai, Mallorca and Warsaw.',
  },
  {
    name: 'AI-OS & Agents',
    description:
      'Through LAEBEL Labs: proprietary agents, RAG memory and automated workflows that cut production costs by up to 90% at ten times the speed.',
  },
  {
    name: 'Spaces',
    description:
      'Physical environments for hospitality, longevity and residential assets — translating the K&K philosophy into spaces people belong to.',
  },
  {
    name: 'Distribution',
    description:
      'What we produce, SuperLuxury distributes: reaching an audience of more than 1.2 million across the channels that matter to it.',
  },
  {
    name: 'Equity & Ventures',
    description:
      'Through LAEBEL Ventures, we exchange media power, AI infrastructure and brand building for real equity in companies and real assets.',
  },
]
